export default __webpack_public_path__ + "static/media/Measuring-tape.b25f04f5.svg";